import React, { useEffect, useRef } from "react";
const HistogramRelatif = ({ data, mediane, indexSensor, unit }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");

    // Obtenir les dimensions de la fenêtre
    const vw = Math.min(window.innerWidth - 20);
    const vh = Math.max(window.innerHeight - 100);

    const width = 0.8 * vw + 0.08 * vh;
    const height = 0.005 * vw + 0.5 * vh;

    // Augmenter la hauteur du canvas pour donner plus d'espace à 'unit'
    const extraTopSpace = 35; // Ajouter de l'espace supplémentaire en haut

    // Définir les dimensions du canvas
    canvas.width = width;
    canvas.height = height + extraTopSpace; // Augmenter la hauteur du canvas

    /* Paramètres */
    const marginHisto = 0.03 * vw + extraTopSpace; // Ajuster la marge pour considérer l'espace supplémentaire
    const y_start = marginHisto / 2 + 0.02 * vh;
    const arrowSize = 0.002 * vw + 0.01 * vh;
    const epaisseurAxe = 0.001 * vw + 0.002 * vh;
    const padding_histo = 0.005 * vw + 0.005 * vh;
    const fontSize = 0.013 * vw + 0.013 * vh; // Définir la taille de la police

    if (!data || data.length === 0) {
      ctx.clearRect(0, 0, width, canvas.height);
      return;
    }

    // Utiliser adjustedDebit et médiane ajustée

    const dataValues = data.map((v) => v.adjustedDebit - mediane);
    const abs_max_value = Math.max(...dataValues.map(Math.abs));

    // Calcul de l'espacement initial dynamique
    const initialSpacing = 0.05 * width - 15; // 5% de la largeur totale moins 15px

    // Ajouter une marge à droite pour centrer le graphique
    const rightMargin = 0.05 * width + 5; // Marge droite égale à 5% de la largeur totale + 5px

    // Calculer la largeur des barres en considérant l'espacement initial et la marge droite
    const barAreaWidth = width - marginHisto - initialSpacing - rightMargin;
    const barWidth = barAreaWidth / dataValues.length;
    ctx.clearRect(0, 0, width, canvas.height);

    // Définir l'épaisseur de la ligne
    ctx.lineWidth = epaisseurAxe;

    // Dessiner les barres de l'histogramme
    dataValues.forEach((value, index) => {
      const x = marginHisto + barWidth * index + initialSpacing;
      const barHeight =
        (value * (height / 2 - marginHisto / 2)) / abs_max_value;
      const y = (height + extraTopSpace) / 2 - barHeight;

      ctx.fillStyle =
        index === indexSensor
          ? value > 0
            ? "#a5163f" // rouge
            : "#49b757" // vert
          : "grey"; // gris clair#24242400

      ctx.fillRect(x, y, barWidth - padding_histo, barHeight);
    });

    ctx.fillStyle = "#000000";

    // Dessiner les axes ajustés
    ctx.beginPath();
    ctx.moveTo(y_start + initialSpacing, canvas.height);
    ctx.lineTo(y_start + initialSpacing, extraTopSpace); // Déplacer l'axe Y jusqu'en haut du canvas
    ctx.moveTo(y_start + initialSpacing, (height + extraTopSpace) / 2);
    ctx.lineTo(width - rightMargin, (height + extraTopSpace) / 2); // Axe X avec marge droite
    ctx.stroke();

    // Flèche pour l'axe Y (déplacée en haut de l'axe Y)
    ctx.beginPath();
    ctx.moveTo(
      y_start + initialSpacing - arrowSize / 1.5,
      extraTopSpace + arrowSize
    );
    ctx.lineTo(y_start + initialSpacing, extraTopSpace);
    ctx.lineTo(
      y_start + initialSpacing + arrowSize / 1.5,
      extraTopSpace + arrowSize
    );
    ctx.fill();

    // Flèche pour l'axe X
    // ctx.beginPath();
    // ctx.moveTo(width - arrowSize * , (height + extraTopSpace) / 2 + arrowSize);
    // ctx.lineTo(width - arrowSize, (height + extraTopSpace) / 2);
    // ctx.lineTo(width - arrowSize * 0, (height + extraTopSpace) / 2 - arrowSize);
    // ctx.fill();

    // Ajouter le mot 'Médiane' à la fin de l'axe X
    ctx.fillStyle = "#000000";
    ctx.font = "bold " + fontSize + "px Montserrat";
    ctx.textAlign = "right";
    ctx.fillText(
      "Moyenne",
      width - rightMargin - 10,
      (height + extraTopSpace) / 2 - 10
    );

    // Ajouter l'unité à la fin de la flèche de l'axe Y (horizontal)
    ctx.textAlign = "center";
    ctx.fillText(unit, y_start + initialSpacing, extraTopSpace - 10); // Ajuster la position si nécessaire
  }, [data, mediane, indexSensor, unit]);

  return <canvas className="histoc" ref={canvasRef} />;
};

export default HistogramRelatif;
